function CloseMenuIconButton({
    width,
    height,
    onClose,
    fill,
}: {
    fill: string;
    width: number;
    height: number;
    onClose: () => void;
}) {
    return (
        <button onClick={onClose}>
            <svg
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={height}
                fill={fill}
            >
                <path d="M878.933333 204.8l-59.733333-59.733333-307.2 307.2-307.2-307.2-59.733333 59.733333 307.2 307.2-307.2 307.2 59.733333 59.733333 307.2-307.2 307.2 307.2 59.733333-59.733333-307.2-307.2z"></path>
            </svg>
        </button>
    );
}
export default CloseMenuIconButton;
